export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

function createRequestTypes(base) {
  const res = {};
  [REQUEST, SUCCESS, FAILURE].forEach((type) => { res[type] = `${base}_${type}`; });
  return res;
}

export const CHARGERS = createRequestTypes('CHARGERS');
export const CHARGERS_NEAR_USER = createRequestTypes('CHARGERS_NEAR_USER');
export const CHARGERS_NEAR_USER_NEXT = createRequestTypes('CHARGERS_NEAR_USER_NEXT');
export const PLACES = createRequestTypes('PLACES');
export const CACHED_CHARGERS = createRequestTypes('CACHED_CHARGERS');
export const CHARGERS_NEAR_IP = createRequestTypes('CHARGERS_NEAR_IP');
export const CHARGER_REVIEWS = createRequestTypes('CHARGER_REVIEWS');
export const CHARGER_IMAGES = createRequestTypes('CHARGER_IMAGES');
export const NEW_CHARGER_REVIEW = 'NEW_CHARGER_REVIEW';
export const NEW_CHARGER_IMAGE = 'NEW_CHARGER_IMAGE';
export const PLACE_REVIEWS = createRequestTypes('PLACE_REVIEWS');
export const NEW_PLACE_REVIEW = 'NEW_PLACE_REVIEW';
export const NEW_PLACE_UPDATE = 'NEW_PLACE_UPDATE';
export const CHARGER_PLACES = createRequestTypes('CHARGER_PLACES');
export const CHARGERS_RANKED = createRequestTypes('CHARGERS_RANKED');
export const NEW_PLACE = 'NEW_PLACE';
export const SET_CHARGER_SHOW_PLACE_CATEGORIES = 'SET_CHARGER_SHOW_PLACE_CATEGORIES';

export const FETCH_CHARGERS = 'FETCH_CHARGERS';
export const FETCH_CHARGERS_NEAR_IP = 'FETCH_CHARGERS_NEAR_IP';
export const GEOLOCATION = createRequestTypes('GEOLOCATION');

export const CURRENT_USER = createRequestTypes('CURRENT_USER');
export const USER = createRequestTypes('USER');
export const USERS = createRequestTypes('USERS');
export const UPDATE_USER = 'UPDATE_USER';
export const LOGIN = createRequestTypes('LOGIN');
export const LOGOUT = createRequestTypes('LOGOUT');

export const SET_CHARGER_FILTER = 'SET_CHARGER_FILTER';
export const CHANGE_MAP = 'CHANGE_MAP';
export const CHARGER_MAP_CLICK = 'CHARGER_MAP_CLICK';
export const SET_CURRENT_CHARGER = 'SET_CURRENT_CHARGER';
export const SET_CENTER_ON_CURRENT_LOCATION = 'SET_CENTER_ON_CURRENT_LOCATION';

export const COUNTRIES = createRequestTypes('COUNTRIES');
export const STATES = createRequestTypes('STATES');
export const PAGE = 'PAGE';



// WEBPACK FOOTER //
// ./app/scripts/constants/ActionTypes.js